import _taggedTemplateLiteral from '../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled, css } from '@mgmresorts/wcl-styled';

var _templateObject, _templateObject2, _templateObject3;
var spacingMap = {
  medium: 4,
  large: 8
};
var alignmentMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};
var childLayoutMap = {
  flex: {
    flexGrow: 1
  },
  'inline-flex': {},
  'flex-equal': {
    flexGrow: 1,
    flexBasis: 0
  },
  'inline-flex-equal': {
    flexGrow: 1,
    flexBasis: 0,
    alignSelf: 'baseline'
  },
  blocks: {},
  justified: {}
};
var StyledButtonGroup = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: ", ";\n  margin: -", "px;\n  justify-content: ", ";\n  ", ";\n"])), function (props) {
  return props.layout === 'inline-flex' ? 'inline-flex' : 'flex';
}, function (props) {
  return spacingMap[props.spacing];
}, function (props) {
  return props.align ? alignmentMap[props.align] : null;
}, function (props) {
  return props.layout === 'blocks' && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      flex-direction: column;\n    "])));
});
var StyledButtonGroupItem = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  margin: ", "px;\n  display: flex;\n"])), function (props) {
  return childLayoutMap[props.layout];
}, function (props) {
  return spacingMap[props.spacing];
});

export { StyledButtonGroup, StyledButtonGroupItem, alignmentMap, childLayoutMap, spacingMap };
